import * as Screen from "../lib/Screen.ts";
import * as libLocation from "../lib/location.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.ts";
import  {Calendar} from "../lib/fullcalendar/all.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import * as calendar_modal from "../calendar/calendar_modal.ts";
import * as currentCalendar from "./currentTimetable.ts";
import FizConfig from "../FizConfig.ts";

INR.onPage(INR.URL.TIMETABLE_NC,async function(){
  let
    token = libLocation.getURLParam("v"),
    calSharedBean = await ApiServer.evtncsync(token);

  setCurrentTimeTable(calSharedBean.calendar,calSharedBean.syncBean)
});


function setCurrentTimeTable(calendar,syncBean){
  let
    currenttimetable = calendar.timetable;
  document.getElementById('timetableswitch').innerText = currenttimetable.name
  var
    weeks = currenttimetable.isOneTime?[]:currenttimetable.weeks,
    range = currenttimetable.isOneTime?null:{
      start:weeks[0].start,
      end:weeks[weeks.length-1].end
    };
  var initialView = currentCalendar.getView(currenttimetable)
  currentCalendar.set(new Calendar(document.getElementById("fullcalendar"),{
    initialView,
    locale: i18n.getSelectedLanguage(),
    allDaySlot:false,
    firstDay:currenttimetable.calendarFirstDayOfWeek%7,
    initialDate: currenttimetable.currentDate,
    validRange: range,
    weekends:currenttimetable.showWeekends,
    scrollTime:'08:00:00',
    height:"parent",
    editable: true,
    //buttonText:i18n.get('eventCalendarNav'),
    headerToolbar: false,
    eventDisplay:'block',
    dayHeaderFormat:{ weekday: Screen.isMobileView()?'short':'long' },
    events: function(range, successCallback,failureCallback){
      var
        intervalEvent = [];

      syncBean.updatedCreated.forEach((event)=>{
        event.listInterval(range).forEach(eventInstance=>{
          eventInstance.calendar = calendar
          FwDatas.cache(eventInstance)
          intervalEvent.push(eventInstance);
          eventInstance.rights = {}
          eventInstance.colorUI = eventInstance.color = (event.colorDB || event.colorAttendee  || FizConfig.defaultColor);
        });
      });
      return successCallback(intervalEvent.map(instance=>{
        return {
          start:instance.start,
          end:instance.end,
          title:instance.title+'\r\n'+(instance.description?instance.description+'\r\n':''),
          classNames:"fw-pre-line",
          description:instance.description,
          color:typeof instance.color==='function'?instance.color():instance.color,
          id:instance.metaId,
          allDay:instance.allDay,
          editable:instance.editable
        }
      }));
    },
    datesSet:function(info){
      currentCalendar.updateViewSelector(currenttimetable,info)
    },
    selectable:false,
    eventClick:async function(obj){
      var
        id = obj.event.id,
        evtFw = FwDatas.get(id);
      if(evtFw){
        await calendar_modal.viewEventDetails(evtFw,true)
        document.querySelectorAll('*[data-key]').forEach(el => (el as HTMLElement).style.display = 'none');
      }else{
        ApiServer.webjslog("Fullcalendar click : cannot find "+id+" in cache");
      }

    }
  }),currenttimetable);
  currentCalendar.get().render();

}
